<div class="row">
    <app-cybersocxmenu></app-cybersocxmenu>
</div>
<div class="col-12">
    <app-incidentform (searchEmitter)="search($event)" #incidentForm> </app-incidentform>

    <ul class="nav nav-tabs">
        <li class="nav-item">
            <a
                class="nav-link"
                [ngClass]="{ active: page === 'notification' }"
                (click)="page = 'notification'; selectDisplayedCases()"
                >{{ 'pages.cybersocxdr.dashboard.notification' | translate }}</a
            >
        </li>
        <li class="nav-item">
            <a
                class="nav-link"
                [ngClass]="{ active: page === 'investigation' }"
                (click)="page = 'investigation'; selectDisplayedCases()"
                >{{ 'pages.cybersocxdr.dashboard.investigation' | translate }}
            </a>
        </li>
    </ul>
    <div class="row gx-2" *ngIf="page === 'notification'">
        <div class="col-12 col-xl-6 py-2 position-relative">
            <app-slagauge
                class="card"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.SLANotificationGauge' | translate }}"
                [data]="slaNotifGaugeData"
            ></app-slagauge>
        </div>

        <div class="col-12 col-xl-6 py-2">
            <app-areaovertime
                class="card"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.MTTDOvertime' | translate }}"
                [data]="mttdData"
                [isStacking]="false"
                [average]="true"
                titleY="Time in minutes"
            ></app-areaovertime>
        </div>

        <div class="col-12 col-xl-6 py-2">
            <app-barovertime
                class="card"
                [isStacking]="true"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.SLANotificationStatusRateOvertime' | translate }}"
                [data]="slaNotifStatusRateData"
                titleY="% of status"
            ></app-barovertime>
        </div>

        <div class="col-12 col-xl-6 py-2">
            <app-areaovertime
                class="card"
                suffix="incident(s)"
                [createdTo]="createdTo"
                [createdFrom]="createdFrom"
                [isStacking]="true"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.SLANotificationStatusOvertime' | translate }}"
                [data]="histogramSLANotifStatusData"
                titleY="Number of incidents"
            ></app-areaovertime>
        </div>

    </div>

    <div class="row gx-2" *ngIf="page === 'investigation'">
        <div class="col-12 col-xl-6 py-2 position-relative">
            <app-slagauge
                class="card"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.SLAInvestigationGauge' | translate }}"
                [data]="slaInvestGaugeData"
            ></app-slagauge>
        </div>

        <div class="col-12 col-xl-6 py-2">
            <app-areaovertime
                class="card"
                [isStacking]="false"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.MTTIOvertime' | translate }}"
                titleY="MTTI in minutes"
                [average]="true"
                [data]="mttiData"
                titleY="Time in minutes"
            ></app-areaovertime>
        </div>

        <div class="col-12 col-xl-6 py-2">
            <app-barovertime
                class="card"
                [isStacking]="true"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.SLAInvestigationStatusRateOvertime' | translate }}"
                [data]="slaInvestRateData"
                titleY="% of status"
            ></app-barovertime>
        </div>

        <div class="col-12 col-xl-6 py-2">
            <app-areaovertime
                class="card"
                [isStacking]="true"
                suffix="incident(s)"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.SLAInvestigationStatusOvertime' | translate }}"
                [data]="histogramSLAInvestStatusData"
                titleY="Number of incidents"
            ></app-areaovertime>
        </div>
    </div>

    <app-microsoccase-list
            title="{{ 'pages.cybersocxdr.menu.similarIncident' | translate }}"
            [loaded]="true"
            [cases]="displayedCases"
            [flags]="[]"
            [main]="'false'"
        ></app-microsoccase-list>
</div>
